const pageId = '251102';

export default {
  pageName: 'Weekly Report Official Accounts Performance',
  pageId,
  pagePath:
    '/opinion/CustomizedReports/WeeklyReport/OfficialAccountsPerformance',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
};
